/**
 * A no-op logger
 */
var UnitTestLogger = /** @class */ (function () {
    function UnitTestLogger() {
    }
    UnitTestLogger.prototype.sendTraceTag = function () { };
    UnitTestLogger.prototype.shipAssertTag = function () { };
    UnitTestLogger.prototype.debugAssertTag = function () { };
    return UnitTestLogger;
}());
export { UnitTestLogger };
//# sourceMappingURL=UnitTestLogger.js.map